import { i18n } from "@/utils/i18n";
import { Alert, Typography, styled } from "@mui/material";
import { ComponentType } from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";

type Config = {
    component: string;
};

const withErrorBoundary =
    (config: Config) =>
    <P extends object>(Component: ComponentType<P>) => {
        const EnhancedComponent = (props: P) => {
            return (
                <ErrorBoundary
                    FallbackComponent={fallbackProps => (
                        <FallbackComponent {...fallbackProps} config={config} />
                    )}
                >
                    <Component {...props} />
                </ErrorBoundary>
            );
        };

        return EnhancedComponent;
    };

const FallbackComponent: React.FC<FallbackProps & { config: Config }> = ({ error }) => {
    return (
        <Styled.Container>
            <Alert severity="warning">{i18n.t("alert.error")}</Alert>
            {error ? (
                <Typography margin="20px 0px" variant="body2" padding="0px 20px" textAlign="center">
                    {error?.toString()}
                </Typography>
            ) : null}
        </Styled.Container>
    );
};

export default withErrorBoundary;

const Styled = {
    Container: styled("div")`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 20px 0px;
        padding: 0px 25px;
        flex: 1;
    `,
};
